export const LOGIN_CONSENT_ELEVATION_BASE = 10;
